"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Burger = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const time = 0.1;
const Styled = styled_components_1.default.div `
	cursor: pointer;
	height: ${(p) => p.theme.navHeight}px;

	&.open {
		.burger {
			background: transparent;
			transition: background ${time}s ${(p) => p.theme.easing};
			&::before,
			&::after {
				top: 0;
				transition: top ${time}s ${(p) => p.theme.easing}, ${time}s transform ${time}s ${(p) => p.theme.easing};
			}
			&::before {
				transform: translate3d(0, 0, 0) rotate(-45deg);
			}
			&::after {
				transform: translate3d(0, 0, 0) rotate(45deg);
			}
		}
	}
`;
const Icon = styled_components_1.default.span `
	margin: 24px 15px;
	width: 30px;
	height: 3px;
	background: ${(p) => (p.accentColor ? p.theme.palette.accent.backgroundText : p.theme.palette.text.primary)};
	display: block;
	border-radius: 2px;
	position: relative;
	transition: ${time * 2}s background ${time / 2}s ${(p) => p.theme.easing};

	&::before,
	&::after {
		content: "";
		box-sizing: border-box;
		display: block;
		width: 30px;
		height: 3px;
		border-radius: 2px;
		position: absolute;
		transform-origin: 50% 50%;
		transition: transform ${time}s ${(p) => p.theme.easing}, ${time}s top ${time}s ${(p) => p.theme.easing};
		background: ${(p) => (p.accentColor ? p.theme.palette.accent.backgroundText : p.theme.palette.text.primary)};
	}

	&::before {
		top: -8px;
	}
	&::after {
		top: 8px;
	}

	${(p) => p.theme.breakpoints.down("xs")} {
		margin: 24px 10px;
		width: 24px;
		&::before,
		&::after {
			width: 24px;
		}
	}
`;
const Burger = ({ menuOpen, accentColor }) => {
    return (react_1.default.createElement(Styled, { className: `burger-wrap ${menuOpen ? " open" : ""}` },
        react_1.default.createElement(Icon, { className: "burger", accentColor: accentColor })));
};
exports.Burger = Burger;
//# sourceMappingURL=Burger.atom.js.map